import { type ButtonHTMLAttributes, type DetailedHTMLProps, type ReactElement } from 'react'
import * as S from './button.styled'

export function Button (props: DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>): ReactElement {
  return <S.Button {...props} />
}
